import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=adf506a6&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=adf506a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf506a6",
  null
  
)

export default component.exports